module.exports = __webpack_public_path__ + "img/icon_tip_close.16580c37.svg";